
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    var name = localStorage.getItem('name') || '';
    var firstName = name ? name.trim().split(/\s+/)[0] : '';
    var hour = new Date().getHours();
    var greeting = 'Hello';
    if (hour < 12)
      greeting = 'Good morning';
    else if (hour < 17)
      greeting = 'Good afternoon';
    else
      greeting = 'Good evening';
    return {
      greeting: greeting,
      firstName: firstName
    };
  },
  on: {
    pageAfterIn: function (e, page) {
      const app = this.$app;
      var city = localStorage.getItem('city');
      var ss = app.smartSelect.get('.smart-select');
      if (ss && city)
        ss.setValue(city);
      var pc = page.el.querySelector('.page-content');
      var hero = page.el.querySelector('.home-hero');
      if (pc && hero) {
        var threshold = hero.offsetHeight - 60;
        var onScroll = function () {
          if (pc.scrollTop > threshold) {
            page.el.classList.add('home-scrolled');
          } else {
            page.el.classList.remove('home-scrolled');
          }
        };
        pc.addEventListener('scroll', onScroll, { passive: true });
      }
    },
    pageBeforeIn: function (e, page) {
      this.$app.statusbar.setBackgroundColor('#ffffff');
      this.$app.statusbar.setTextColor('black');
    }
  },
  id: '338e48999d',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n    <div class="page" id="homePage" data-name="home">\r\n        <div class="navbar home-navbar">\r\n            <div class="navbar-inner">\r\n                <div class="left">\r\n                    <a href="/left-panel/" class="link icon-only panel-open" data-panel="left" aria-label="Open menu">\r\n                        <i class="icon f7-icons if-not-md">menu</i>\r\n                        <i class="icon material-icons md-only">menu</i>\r\n                    </a>\r\n                </div>\r\n                <div class="title title_cstm home-logo-title">\r\n                    <img src="static/img/mdoc-logo.svg" alt="mDOC" class="navbar-logo">\r\n                </div>\r\n                <div class="right">\r\n                    <a href="/notification/" class="link icon-only" aria-label="Notifications">\r\n                        <i class="icon f7-icons if-not-md">bell</i>\r\n                        <i class="icon material-icons md-only">notifications_none</i>\r\n                    </a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class="page-content home-content">\r\n\r\n            <!-- Hero: greeting + location + search + offers ribbon -->\r\n            <section class="home-hero" aria-labelledby="home-hero-title">\r\n                <div class="home-hero-bg"></div>\r\n                <div class="home-hero-inner">\r\n                    <div class="home-hero-top">\r\n                        <div class="home-hero-greeting">\r\n                            <div class="home-hero-hi">';
      r += c(ctx_1.greeting, ctx_1);
      r += Template7Helpers.js_if.call(ctx_1, 'this.firstName', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ', ';
          r += c(ctx_2.firstName, ctx_2);
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div>\r\n                            <div class="home-hero-sub" id="home-hero-title">How can we help you today?</div>\r\n                        </div>\r\n                        <a class="link location-chip smart-select smart-select-init" data-close-on-select="true" data-page-title="Select City" aria-label="Select city">\r\n                            <i class="icon f7-icons if-not-md">placemark</i>\r\n                            <i class="icon material-icons md-only">location_on</i>\r\n                            <select id="selectCity" name="city">\r\n                                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.city, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                                <option value="';
          r += c(ctx_2.id, ctx_2);
          r += '">';
          r += c(ctx_2.name, ctx_2);
          r += '</option>\r\n                                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n                            </select>\r\n                            <div class="item-content"><div class="item-inner"><div class="item-title"></div></div></div>\r\n                        </a>\r\n                    </div>\r\n\r\n                    <a href="/search/" class="home-search-bar link" aria-label="Search doctors, hospitals, tests">\r\n                        <i class="icon f7-icons if-not-md">search</i>\r\n                        <i class="icon material-icons md-only">search</i>\r\n                        <span>Search doctors, hospitals, tests\u2026</span>\r\n                    </a>\r\n\r\n                    <a href="/offers/" class="link offers-ribbon" aria-label="View today\'s offers">\r\n                        <i class="icon f7-icons if-not-md">tag_fill</i>\r\n                        <i class="icon material-icons md-only">local_offer</i>\r\n                        <span class="offers-ribbon-text">Today\'s offers</span>\r\n                        <span class="offers-ribbon-cta">View\r\n                            <i class="icon f7-icons if-not-md">chevron_right</i>\r\n                            <i class="icon material-icons md-only">chevron_right</i>\r\n                        </span>\r\n                    </a>\r\n                </div>\r\n            </section>\r\n\r\n            <!-- Continuity: upcoming appointment + recent doctors -->\r\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.upcomingAppointment', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <a href="/appointmentDetails/';
          r += c(ctx_2.upcomingAppointment.id, ctx_2);
          r += '" class="upcoming-appointment-card link" aria-label="View upcoming appointment">\r\n                <div class="upcoming-left">\r\n                    <div class="upcoming-label">\r\n                        <i class="icon f7-icons if-not-md">calendar_badge_plus</i>\r\n                        <i class="icon material-icons md-only">event_available</i>\r\n                        <span>Upcoming appointment</span>\r\n                    </div>\r\n                    <div class="upcoming-doctor">';
          r += c(ctx_2.upcomingAppointment.doctor_name, ctx_2);
          r += '</div>\r\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.upcomingAppointment.department_name', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                    <div class="upcoming-dept">';
              r += c(ctx_3.upcomingAppointment.department_name, ctx_3);
              r += '</div>\r\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                    <div class="upcoming-when">\r\n                        <i class="icon f7-icons if-not-md">clock</i>\r\n                        <i class="icon material-icons md-only">schedule</i>\r\n                        <span>';
          r += c(ctx_2.upcomingAppointment.relative_label, ctx_2);
          r += Template7Helpers.js_if.call(ctx_2, 'this.upcomingAppointment.time', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' \xB7 ';
              r += c(ctx_3.upcomingAppointment.time, ctx_3);
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span>\r\n                    </div>\r\n                </div>\r\n                <div class="upcoming-right">\r\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.upcomingAppointment.doctor_photo', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                    <img src="';
              r += c(ctx_3.upcomingAppointment.doctor_photo, ctx_3);
              r += '" alt="" onerror="this.src=\'static/img/default_doctor.svg\'">\r\n                    ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                    <img src="static/img/default_doctor.svg" alt="">\r\n                    ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                    <i class="icon f7-icons if-not-md upcoming-arrow">chevron_right</i>\r\n                    <i class="icon material-icons md-only upcoming-arrow">chevron_right</i>\r\n                </div>\r\n            </a>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.recentDoctors && this.recentDoctors.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="hspt-heading"><span>Book again</span></div>\r\n            <div class="recent-doctors-scroll">\r\n                <div data-space-between="10" data-slides-per-view="auto" data-slides-offset-before="14" data-slides-offset-after="14" data-free-mode="true" class="swiper-container swiper-init recent-doctors-swiper">\r\n                    <div class="swiper-wrapper">\r\n                        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.recentDoctors, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                        <a href="/booking/';
              r += c(ctx_3.id, ctx_3);
              r += '/Normal" class="swiper-slide recent-doctor-card" aria-label="Book ';
              r += c(ctx_3.name, ctx_3);
              r += '">\r\n                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.photo', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                            <img class="recent-doctor-photo" src="';
                  r += c(ctx_4.photo, ctx_4);
                  r += '" alt="" onerror="this.src=\'static/img/default_doctor.svg\'">\r\n                            ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                            <img class="recent-doctor-photo" src="static/img/default_doctor.svg" alt="">\r\n                            ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                            <div class="recent-doctor-name">';
              r += c(ctx_3.name, ctx_3);
              r += '</div>\r\n                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.department_name', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                            <div class="recent-doctor-dept">';
                  r += c(ctx_4.department_name, ctx_4);
                  r += '</div>\r\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                            <div class="recent-doctor-cta">Book again</div>\r\n                        </a>\r\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n            <!-- Services: 2 hero cards (primary) + compact grid (secondary) -->\r\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.module && this.module.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="hspt-heading"><span>Our Services</span></div>\r\n\r\n            <div class="service-hero-row">\r\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.module, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                ';
              r += Template7Helpers.js_if.call(ctx_3, '@index < 2', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                <a href="';
                  r += c(ctx_4.link, ctx_4);
                  r += '" class="service-hero-card';
                  r += Template7Helpers.js_if.call(ctx_4, '@index == 0', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += ' service-hero-green';
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += ' service-hero-blue';
                      return r;
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '" aria-label="';
                  r += c(ctx_4.name, ctx_4);
                  r += '">\r\n                    <div class="service-hero-body">\r\n                        <div class="service-hero-title">';
                  r += c(ctx_4.name, ctx_4);
                  r += '</div>\r\n                        ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.description', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\r\n                        <div class="service-hero-sub">';
                      r += c(ctx_5.description, ctx_5);
                      r += '</div>\r\n                        ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\r\n                        <div class="service-hero-cta">\r\n                            <span>Book now</span>\r\n                            <i class="icon f7-icons if-not-md">arrow_right</i>\r\n                            <i class="icon material-icons md-only">arrow_forward</i>\r\n                        </div>\r\n                    </div>\r\n                    <div class="service-hero-icon">\r\n                        <img src="';
                  r += c(ctx_4.icon_url, ctx_4);
                  r += '" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\r\n                    </div>\r\n                    <div class="service-hero-decoration"></div>\r\n                </a>\r\n                ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n            </div>\r\n\r\n            ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.module.length > 2', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n            <div class="services-grid">\r\n                ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.module, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                ';
                  r += Template7Helpers.js_if.call(ctx_4, '@index >= 2', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\r\n                <a href="';
                      r += c(ctx_5.link, ctx_5);
                      r += '" class="service-tile-v2" aria-label="';
                      r += c(ctx_5.name, ctx_5);
                      r += '">\r\n                    <div class="service-tile-v2-icon">\r\n                        <img src="';
                      r += c(ctx_5.icon_url, ctx_5);
                      r += '" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\r\n                    </div>\r\n                    <div class="service-tile-v2-name">';
                      r += c(ctx_5.name, ctx_5);
                      r += '</div>\r\n                </a>\r\n                ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\r\n                ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n            </div>\r\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n            <!-- Promo / Main Slider (currently disabled) -->\r\n            <!-- ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.slider && this.slider.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div id="slider2" class="home-slider">\r\n                <div data-autoplay="true" data-loop="true" data-space-between="10" data-slides-per-view="1" data-slides-offset-before="14" data-slides-offset-after="14" class="swiper-container swiper-init home-slider-swiper">\r\n                    <div class="swiper-wrapper">\r\n                        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.slider, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                        <div class="swiper-slide" style="background-image: url(';
              r += c(ctx_3.image_url, ctx_3);
              r += ');"></div>\r\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' -->\r\n\r\n            <!-- Care Plans -->\r\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.package && this.package.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="hspt-heading"><span>Care Plans</span></div>\r\n            <div class="section-subtitle">Save more on regular check-ups &amp; consultations</div>\r\n            <div class="plan-cards">\r\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.package, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                <a href="/subscription-single/';
              r += c(ctx_3.id, ctx_3);
              r += '/" class="plan-card';
              r += Template7Helpers.js_if.call(ctx_3, '@index % 2 == 0', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' plan-card-primary';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += ' plan-card-secondary';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '" aria-label="';
              r += c(ctx_3.name, ctx_3);
              r += '">\r\n                    ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.badge', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                    <div class="plan-badge">';
                  r += c(ctx_4.badge, ctx_4);
                  r += '</div>\r\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                    <div class="plan-card-illust">\r\n                        <img src="';
              r += c(ctx_3.image_url, ctx_3);
              r += '" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\r\n                    </div>\r\n                    <div class="plan-card-body">\r\n                        <div class="plan-card-title">';
              r += c(ctx_3.name, ctx_3);
              r += '</div>\r\n                        <div class="plan-features">\r\n                            ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.features, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                            <div class="plan-feature">\r\n                                <i class="icon f7-icons if-not-md">checkmark_alt_circle_fill</i>\r\n                                <i class="icon material-icons md-only">check_circle</i>\r\n                                <span>';
                  r += c(ctx_4, ctx_4);
                  r += '</span>\r\n                            </div>\r\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.validity', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                            <div class="plan-feature">\r\n                                <i class="icon f7-icons if-not-md">calendar_circle_fill</i>\r\n                                <i class="icon material-icons md-only">date_range</i>\r\n                                <span>';
                  r += c(ctx_4.validity, ctx_4);
                  r += ' months validity</span>\r\n                            </div>\r\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                        </div>\r\n                        <div class="plan-card-footer">\r\n                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.amount', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                            <div class="plan-price">\r\n                                <span class="plan-price-currency">\u20B9</span>\r\n                                <span class="plan-price-amount">';
                  r += c(ctx_4.amount, ctx_4);
                  r += '</span>\r\n                            </div>\r\n                            ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                            <div class="plan-price plan-price-empty"></div>\r\n                            ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                            <div class="plan-card-cta">\r\n                                <span>View</span>\r\n                                <i class="icon f7-icons if-not-md">arrow_right</i>\r\n                                <i class="icon material-icons md-only">arrow_forward</i>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class="plan-card-blob"></div>\r\n                </a>\r\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n            <!-- Speciality (horizontal scroll) -->\r\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.departmentLimited && this.departmentLimited.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="hspt-heading">\r\n                <span>Find Doctor by Speciality</span>\r\n                <a href="/all-specialities/" class="more-link">More</a>\r\n            </div>\r\n            <div class="specialities-scroll">\r\n                <div data-space-between="10" data-slides-per-view="auto" data-slides-offset-before="14" data-slides-offset-after="14" data-free-mode="true" class="swiper-container swiper-init specialities-swiper">\r\n                    <div class="swiper-wrapper">\r\n                        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.departmentLimited, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                        <div class="swiper-slide speciality-card">\r\n                            <a href="/doctors/';
              r += c(ctx_3.id, ctx_3);
              r += '/';
              r += c(ctx_3.name, ctx_3);
              r += '/" aria-label="';
              r += c(ctx_3.name, ctx_3);
              r += '">\r\n                                <div class="speciality-icon">\r\n                                    <img src="';
              r += c(ctx_3.image_url, ctx_3);
              r += '" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\r\n                                </div>\r\n                                <div class="speciality-name">';
              r += c(ctx_3.name, ctx_3);
              r += '</div>\r\n                            </a>\r\n                        </div>\r\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n            <!-- Hospitals (2-col cards) -->\r\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.hospitalLimited && this.hospitalLimited.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="hspt-heading">\r\n                <span>Find Doctors in Top Hospitals</span>\r\n                <a href="/all-hospitals/" class="more-link">More</a>\r\n            </div>\r\n            <div class="hospitals-grid">\r\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.hospitalLimited, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                <a href="/hospital/';
              r += c(ctx_3.id, ctx_3);
              r += '/';
              r += c(ctx_3.name, ctx_3);
              r += '/" class="hospital-card-v2" aria-label="';
              r += c(ctx_3.name, ctx_3);
              r += '">\r\n                    <div class="hospital-card-v2-image">\r\n                        <img src="';
              r += c(ctx_3.image_url, ctx_3);
              r += '" alt="" onerror="this.src=\'static/img/default_hospital.svg\'">\r\n                    </div>\r\n                    <div class="hospital-card-v2-name">';
              r += c(ctx_3.name, ctx_3);
              r += '</div>\r\n                </a>\r\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n            <!-- Why mDOC: trust block (Achievements + Vision tagline) -->\r\n            <div class="hspt-heading"><span>Why mDOC</span></div>\r\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.vision && this.vision.body', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="section-subtitle">';
          r += c(ctx_2.vision.body, ctx_2);
          r += '</div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n            <div class="achievements-grid">\r\n                <div class="achievement-tile">\r\n                    <i class="icon f7-icons if-not-md achievement-ico">person_2_fill</i>\r\n                    <i class="icon material-icons md-only achievement-ico">group</i>\r\n                    <div class="achievement-number">';
      r += c(ctx_1.achievements.users, ctx_1);
      r += '+</div>\r\n                    <div class="achievement-label">Our Users</div>\r\n                </div>\r\n                <div class="achievement-tile">\r\n                    <i class="icon f7-icons if-not-md achievement-ico">heart_fill</i>\r\n                    <i class="icon material-icons md-only achievement-ico">medical_services</i>\r\n                    <div class="achievement-number">';
      r += c(ctx_1.achievements.doctors, ctx_1);
      r += '+</div>\r\n                    <div class="achievement-label">Our Doctors</div>\r\n                </div>\r\n                <div class="achievement-tile">\r\n                    <i class="icon f7-icons if-not-md achievement-ico">house_fill</i>\r\n                    <i class="icon material-icons md-only achievement-ico">local_hospital</i>\r\n                    <div class="achievement-number">';
      r += c(ctx_1.achievements.hospitals, ctx_1);
      r += '+</div>\r\n                    <div class="achievement-label">Hospitals</div>\r\n                </div>\r\n                <div class="achievement-tile">\r\n                    <i class="icon f7-icons if-not-md achievement-ico">checkmark_seal_fill</i>\r\n                    <i class="icon material-icons md-only achievement-ico">verified</i>\r\n                    <div class="achievement-number">';
      r += c(ctx_1.achievements.patients_served, ctx_1);
      r += '+</div>\r\n                    <div class="achievement-label">Patients Served</div>\r\n                </div>\r\n            </div>\r\n\r\n            <!-- Ad slides -->\r\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.adSliders && this.adSliders.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="home-adslides">\r\n                <div data-autoplay="true" data-loop="true" data-space-between="10" data-slides-per-view="auto" data-slides-offset-before="12" data-slides-offset-after="12" class="swiper-container swiper-init home-adslides-swiper">\r\n                    <div class="swiper-wrapper">\r\n                        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.adSliders, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                        <div class="swiper-slide ad-slide">\r\n                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.link', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                            <a href="';
                  r += c(ctx_4.link, ctx_4);
                  r += '"><img src="';
                  r += c(ctx_4.image_url, ctx_4);
                  r += '" alt="';
                  r += c(ctx_4.title, ctx_4);
                  r += '"></a>\r\n                            ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                            <img src="';
                  r += c(ctx_4.image_url, ctx_4);
                  r += '" alt="';
                  r += c(ctx_4.title, ctx_4);
                  r += '">\r\n                            ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                        </div>\r\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n            <!-- Testimonials -->\r\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.testimonials && this.testimonials.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="hspt-heading">\r\n                <span>What Our Patients Say</span>\r\n            </div>\r\n            <div class="testimonials">\r\n                <div data-space-between="10" data-slides-per-view="auto" data-slides-offset-before="12" data-slides-offset-after="12" class="swiper-container swiper-init testimonials-swiper">\r\n                    <div class="swiper-wrapper">\r\n                        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.testimonials, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                        <div class="swiper-slide testimonial-card">\r\n                            <div class="testimonial-head">\r\n                                <img class="testimonial-photo" src="';
              r += c(ctx_3.photo_url, ctx_3);
              r += '" onerror="this.src=\'static/img/default_doctor.svg\'">\r\n                                <div class="testimonial-meta">\r\n                                    <div class="testimonial-name">';
              r += c(ctx_3.name, ctx_3);
              r += '</div>\r\n                                    <div class="testimonial-rating">\r\n                                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.rating >= 1', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<i class="icon f7-icons if-not-md">star_fill</i><i class="icon material-icons md-only">star</i>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.rating >= 2', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<i class="icon f7-icons if-not-md">star_fill</i><i class="icon material-icons md-only">star</i>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.rating >= 3', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<i class="icon f7-icons if-not-md">star_fill</i><i class="icon material-icons md-only">star</i>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.rating >= 4', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<i class="icon f7-icons if-not-md">star_fill</i><i class="icon material-icons md-only">star</i>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.rating >= 5', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<i class="icon f7-icons if-not-md">star_fill</i><i class="icon material-icons md-only">star</i>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="testimonial-msg">';
              r += c(ctx_3.message, ctx_3);
              r += '</div>\r\n                        </div>\r\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n            <!-- Get in touch: enquiry + feedback paired -->\r\n            <div class="hspt-heading"><span>Get in touch</span></div>\r\n            <div class="contact-block">\r\n                <div class="contact-row">\r\n                    ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.enquiry.phone', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                    <a href="tel:';
          r += c(ctx_2.enquiry.phone, ctx_2);
          r += '" class="contact-pill external" aria-label="Call us">\r\n                        <i class="icon f7-icons if-not-md">phone_fill</i>\r\n                        <i class="icon material-icons md-only">call</i>\r\n                        <span>Call</span>\r\n                    </a>\r\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n                    ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.enquiry.email', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                    <a href="mailto:';
          r += c(ctx_2.enquiry.email, ctx_2);
          r += '" class="contact-pill external" aria-label="Email us">\r\n                        <i class="icon f7-icons if-not-md">envelope_fill</i>\r\n                        <i class="icon material-icons md-only">mail</i>\r\n                        <span>Email</span>\r\n                    </a>\r\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n                    <a href="/feedback/" class="contact-pill" aria-label="Send feedback">\r\n                        <i class="icon f7-icons if-not-md">chat_bubble_text_fill</i>\r\n                        <i class="icon material-icons md-only">forum</i>\r\n                        <span>Feedback</span>\r\n                    </a>\r\n                </div>\r\n                <div class="contact-details">\r\n                    ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.enquiry.phone', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                    <a href="tel:';
          r += c(ctx_2.enquiry.phone, ctx_2);
          r += '" class="contact-line external">\r\n                        <i class="icon f7-icons if-not-md">phone</i>\r\n                        <i class="icon material-icons md-only">call</i>\r\n                        <span>';
          r += c(ctx_2.enquiry.phone, ctx_2);
          r += '</span>\r\n                    </a>\r\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n                    ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.enquiry.email', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                    <a href="mailto:';
          r += c(ctx_2.enquiry.email, ctx_2);
          r += '" class="contact-line external">\r\n                        <i class="icon f7-icons if-not-md">envelope</i>\r\n                        <i class="icon material-icons md-only">mail</i>\r\n                        <span>';
          r += c(ctx_2.enquiry.email, ctx_2);
          r += '</span>\r\n                    </a>\r\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n                    ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.enquiry.address', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                    <div class="contact-line">\r\n                        <i class="icon f7-icons if-not-md">placemark</i>\r\n                        <i class="icon material-icons md-only">place</i>\r\n                        <span>';
          r += c(ctx_2.enquiry.address, ctx_2);
          r += '</span>\r\n                    </div>\r\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n                </div>\r\n            </div>\r\n\r\n            <!-- Ask Care AI CTA (promoted) -->\r\n            <a href="#" class="ask-ai-cta link external" id="askCareAiBtn" aria-label="Ask Care AI">\r\n                <div class="ask-ai-inner">\r\n                    <div class="ask-ai-badge">\r\n                        <i class="icon f7-icons if-not-md">sparkles</i>\r\n                        <i class="icon material-icons md-only">auto_awesome</i>\r\n                    </div>\r\n                    <div class="ask-ai-text">\r\n                        <div class="ask-ai-title">Ask Care AI</div>\r\n                        <div class="ask-ai-sub">Get instant answers to your health queries</div>\r\n                    </div>\r\n                    <i class="icon f7-icons if-not-md ask-ai-arrow">arrow_right_circle_fill</i>\r\n                    <i class="icon material-icons md-only ask-ai-arrow">arrow_forward</i>\r\n                </div>\r\n            </a>\r\n\r\n            <!-- Footer -->\r\n            <div class="home-footer">';
      r += c(ctx_1.footerText, ctx_1);
      r += '</div>\r\n\r\n        </div>\r\n    </div>\r\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    